import React from "react";
import {autobind} from "core-decorators";
import {disposeOnUnmount, inject, observer} from "mobx-react";
import {gql} from "@apollo/client";
import {CheckCircleTwoTone} from "@ant-design/icons";

import "./SubscriptionProcessing.scss";
import {paths} from "@/routes";
import {SubscriptionStatus, SubscriptionStatusVariables} from "@/graphql/types";
import PageLayout from "@/components/PageLayout/PageLayout";
import Store from "@/stores";

export interface ISubscriptionProcessingProps {
  store?: Store;
}

@inject("store")
@autobind
@observer
export default class SubscriptionProcessing extends React.Component<ISubscriptionProcessingProps> {
  async componentDidMount() {
    const intervalId = setInterval(() => this.checkSubscriptionStatus(), 2000);
    disposeOnUnmount(this, () => clearInterval(intervalId));
  }

  async checkSubscriptionStatus(): Promise<void> {
    const store = this.props.store!;
    const userId = store.session.voicefulUser!.id;
    const result = await store.apollo.client.query<SubscriptionStatus, SubscriptionStatusVariables>({
      query: gql`
        query SubscriptionStatus($userId: Int!) {
          subscriptions(where: {_and: [{user_id: {_eq: $userId}}, {status: {_eq: "active"}}, {trial: {_eq: false}}]}) {
            id
          }
        }
      `,
      variables: {
        userId,
      },
    });
    if (result.data.subscriptions.length > 0) {
      console.log("Active subscription found, redirecting");
      // Update the session to reflect the fact that the user is now subscribed and update the
      // user's ensemble plan.
      await store.session.fetchSessionData();
      store.history.history.push(paths.home());
    }
  }

  render() {
    // TODO: Add a message that shows up after ~20 seconds saying "This is taking longer than
    // usual, please hang on..." and then ~20 seconds later: "There seems to be an issue on our
    // side, please contact support and we'll take care of it for you." This can happen if for
    // some reason the webhook is failing/delayed or there is an error in Chargebee.
    return (
      <PageLayout>
        <div className="SubscriptionSuccess">
          <CheckCircleTwoTone />
          <h1>Thank you for subscribing!</h1>
          <p>Please wait a few seconds while we process your subscription...</p>
        </div>
      </PageLayout>
    );
  }
}
